import { getAxios } from '../utils/requests'
const axios = getAxios()

export default class TagSchemasService {
  async getSchemas () {
    const result = await axios.get('/api/financial_resources/tag_schemas')
    return result.data
  }
}
